"use client";
import { createContext, useState, useContext, ReactNode } from "react";

export type Token = {
   token: string | null;
};

export type TokenContextType = {
    token: Token;
    setToken: (token: Token) => void;
};
const TokenContext = createContext<TokenContextType | undefined>(undefined);
export const TokenProvider: React.FC<{
    children?: ReactNode;
}> = ({ children }) => {
    const [token, setToken]:any = useState<Token>();
    return (
        <TokenContext.Provider value={{ token, setToken }}>
            {children}
        </TokenContext.Provider>
    );
};
export const useToken = () => {
    const context = useContext(TokenContext);
    if (!context) {
        throw new Error("Erreur Context User");
    }
    return context;
};
